<template>

    <v-card class="pa-2 ma-4" outlined>
        <v-card-title>
            <span class="headline">Trip Details</span>
        </v-card-title>
        <v-card-text>


            <v-row>
                <v-col cols="3">
                    {{item.name}}
                </v-col>
                <v-col cols="3">
                    Start Date:&nbsp;{{formatDate(item.startDate)}}
                </v-col>
                <v-col cols="3">
                    End Date:&nbsp;{{formatDate(item.endDate)}}
                </v-col>

                <v-col cols="3">
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary"
                                   dark
                                   class="mb-2"
                                   v-bind="attrs"
                                   v-if="hasAccess('SCHEDULE') || hasAccess('COMPLETERO')"
                                   v-on="on">New Requisition Order</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select v-model="editedItem.orderTypeId"
                                                      :items="orderTypes"
                                                      label="Order Type *"
                                                      item-text="id"
                                                      :item-value="editedItem.orderTypeId"
                                                      :loading="loading"
                                                      required></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select v-model="editedItem.orderSubTypeId"
                                                      :items="filteredOrderSubTypes"
                                                      :disabled="editedItem.orderTypeId?false:true"
                                                      label="Order Sub-Type *"
                                                      item-text="name"
                                                      item-value="id"
                                                      :loading="loading"
                                                      required></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="editedItem.description"
                                                counter=100
                                                label="Description"
                                                v-if="showSubTypeDescription"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <span class="headline">Requisition Orders: &nbsp; {{grandTotal}}</span>
                </v-col>
            </v-row>
            <v-row v-for="(itm, key) in details.requisitionOrders" :key="key">
                <v-col cols="3">
                    <v-btn text :to="{ name: 'requisitionorder', params: { locationId: locationId, locationDepartmentId: locationDepartmentId, id: itm.id }}">
                        <span>
                            <v-icon>mdi-clipboard-check-multiple</v-icon>&nbsp;{{ itm.locationId }}-{{ itm.xId ? itm.xId.toString().padStart(5, '0') : "" }}:
                        </span>
                    </v-btn>
                    <span>&nbsp;{{formatCurrency(itm.totalPrice)}}</span>
                </v-col>
                <v-col cols="3">
                    <span>{{itm.orderStateId}}</span>
                </v-col>

                <v-col cols="3">
                    <span>{{ orderSubTypeName(itm.orderSubTypeId) }}</span><span v-if="itm.description">&nbsp;-&nbsp;{{itm.description}}</span>
                    <v-icon small
                        class="ml-2"
                        v-if="!itm.isComplete && canEdit(itm.orderStateDetails)"
                        @click="editItem(itm)">
                        mdi-pencil
                    </v-icon>
                </v-col>
                <v-col cols="3">
                    <v-checkbox v-model="itm.isActive" :disabled="itm.isActive||itm.orderStateId!='OPEN'" label="Is Active" class="shrink mr-2 mt-0" @click="saveActiveRequisitionOrder(itm)"></v-checkbox>
                </v-col>
            </v-row>

        </v-card-text>
        <v-card-actions>

        </v-card-actions>
    </v-card>

</template>

<script>

    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import moment from 'moment';
    import axios from "axios";
    export default {
        data: () => ({
            dialog: false,
            locationId: null,
            locationDepartmentId: null,
            loading: false,
            orderTypes: [],
            orderSubTypes: [],
            updating: false,
            details: {
                requisitionOrders: [], schedule: {}
            },
            editedIndex: -1,
            editedItem: {
                id: 0,
                description: "",
                locationId: "",
                tripTypeId: "",
                orderTypeId: "",
                orderSubTypeId: null,
                subTypeDescription: "",
                scheduleId: 0,
                isActive: false,
                totalPrice: 0
            },
            defaultItem: {
                id: 0,
                description: "",
                locationId: "",
                tripTypeId: "",
                orderTypeId: "",
                orderSubTypeId: null,
                subTypeDescription: "",
                scheduleId: 0,
                isActive: false,
                totalPrice: 0
            },
        }),
        props: {
            item: {}
        },
        async mounted() {
            //Note: Mounted is not fired when users expand a second expandable
            //      area without collapsing the first. Vue.js reuses components when no key is specified 
            //      Be sure to specify a key on the component <TripDetails :item="item" :key="item.id" />.
            this.loading = true;
            this.locationId = this.$route.params.locationId;
            this.locationDepartmentId = this.$route.params.locationDepartmentId;
            this.loading = true;
            this.details = await this.getScheduleDetailsFromApi(this.item.id);
            this.orderTypes = await this.getOrderTypesFromApi();
            this.orderSubTypes = await this.getOrderSubTypesFromApi();
            this.loading = false;

        },
        methods: {
            ...mapActions(["sendMessage", "refreshActiveTrip", "switchActiveOrder"]),
            async getScheduleDetailsFromApi(id) {

              let response = await axios.get(`/api/schedule/${id}`)
              return response.data;

            },
            async getOrderTypesFromApi() {

              let response = await axios.get(`/api/Lookup/ordertypes`)
              let data = response.data;
              data.sort((a, b) => a.id - b.id);
              return data;

            },
            async getOrderSubTypesFromApi() {

              let response = await axios.get(`/api/Lookup/ordersubtypes/${this.$route.params.locationId}`)
              let data = response.data;
              data.sort((a, b) => a.id.toString().localeCompare(b.id));
              return data;

            },
            async saveData(requisitionOrder) {

                this.loading = true;

                requisitionOrder.errorMessage = '';
                requisitionOrder.hasError = false;

                requisitionOrder.LocationId = this.locationId;
              
                let data = null;
                try {
                  let response = null;
                  if(this.editedIndex==-1) {
                    response = await axios.post(`/api/requisitionorder`,requisitionOrder);
                  }
                  else {
                    response = await axios.put(`/api/requisitionorder`,requisitionOrder);
                  }
                  data=response.data;
                  if(this.isActive && data.isActive) {
                    await this.switchActiveOrder(data.id);
                  }
                  this.loading = false;
                  await this.refreshActiveTrip(true);

                  this.sendMessage({
                    color: "success",
                    text: `The requisition order has been created/updated successfuly.`,
                    timeout: 6000
                  });

                  return response.data;
                }
                catch(error) {
                  this.loading = false;
                  requisitionOrder.errorMessage = 'An unknown network has occurred.';
                  requisitionOrder.hasError = true;

                  this.sendMessage({
                    color: "error",
                    text: `Failed to create/update the requisition order. ${requisitionOrder.errorMessage}`,
                    timeout: 6000
                  });
                  return requisitionOrder;
                }
            },
            async saveActiveRequisitionOrder(requisitionOrder) {

                this.details.requisitionOrders.forEach((item) => {
                    if (item.id != requisitionOrder.id) {
                        item.isActive = false;
                    }
                });

                try {
                    let response = await axios.put(`/api/RequisitionOrder/activerequisitionorder`, requisitionOrder);
                    this.refreshActiveTrip(true);
                    this.$emit('activeOrderChanged');
                    return response.data;
                }
                catch(error) {
                    requisitionOrder.errorMessage = 'An unknown network has occurred.';
                    requisitionOrder.hasError = true;
                    return requisitionOrder;
                }

            },
            editItem(requisition) {
                this.editedIndex = this.details.requisitionOrders.indexOf(requisition);
                this.editedItem = Object.assign({}, requisition);
                this.dialog = true;
            },
            formatDate(date) {
                if (!date) return null

                return moment(String(date)).format('YYYY-MM-DD');
            },
            formatCurrency(price, round) {
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
                if (round) return formatter.format(Math.round(price, 0)).split('.')[0];
                return formatter.format(price);
            },
            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            save(value) {

                this.editedItem.scheduleId = this.item.id;
                this.editedItem.locationId = this.$route.params.locationId;

                this.saveData(this.editedItem)
                    .then(async data => {
                        this.editedItem = data;

                        if (this.editedIndex > -1) {
                            Object.assign(this.details.requisitionOrders[this.editedIndex], this.editedItem);
                        } else {
                            this.details.requisitionOrders.push(this.editedItem);
                        }

                        if (this.editedItem.isActive) {
                            this.details.requisitionOrders.forEach((item) => {
                                if (item.id != this.editedItem.id) {
                                    item.isActive = false;
                                }
                            });
                        }

                        this.close()
                        this.details = await this.getScheduleDetailsFromApi(this.item.id);
                    });

            },
            orderSubTypeName(id){
                let st = this.orderSubTypes.find(ost => ost.id === id)
                return st? st.name : ""
            },
            canEdit(orderStateDetails) {
                if (!orderStateDetails) return false;
                return (
                    (orderStateDetails.isOpen && (this.hasAccess('MATERIALRO'))) || 
                    (orderStateDetails.isProcessing && (this.hasAccess('PROCESSRO')))
                ) 
            },
            ...mapMutations(['setCurrentTrip', 'setCurrentRequisitionOrder']),
        },
        computed: {
            ...mapGetters(['hasAccess']),
            grandTotal() {
                var t = 0;

                this.details.requisitionOrders.forEach((item) => {

                    t += item.totalPrice;
                })

                return this.formatCurrency(t, true);
            },
            filteredOrderSubTypes() {
                if(this.editedItem.orderTypeId) return this.orderSubTypes
                .filter(item => item.orderTypeId == this.editedItem.orderTypeId && !(item.isDeleted || item.isDisabledForLocation))
                .sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 :0))
                return []
            },
            showSubTypeDescription() {
                if(this.editedItem.orderSubTypeId) {
                    let subtype = this.orderSubTypes.find(item => item.id === this.editedItem.orderSubTypeId);
                    return subtype.isDescriptionAllowed
                }
                return false
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Add new Requisition Order' : 'Edit Requisition Order'
            },
            ...mapGetters(['getVrsUser','getCurrentTrip', 'hasAccess'])
        }
    }
</script>
